(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@spiky-panda/core"));
	else if(typeof define === 'function' && define.amd)
		define(["@spiky-panda/core"], factory);
	else if(typeof exports === 'object')
		exports["MurmurationTraining"] = factory(require("@spiky-panda/core"));
	else
		root["MurmurationTraining"] = factory(root["SpikyPanda"]);
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__551__) => {
return 